module.exports = __webpack_public_path__ + "img/box4.ac9f31bc.png";